// removed by extract-text-webpack-plugin
module.exports = {"Loading":"Loading--3N55K"};